import { render, staticRenderFns } from "./proTotal.vue?vue&type=template&id=4c6b90de&scoped=true&"
import script from "./proTotal.vue?vue&type=script&lang=js&"
export * from "./proTotal.vue?vue&type=script&lang=js&"
import style0 from "./proTotal.vue?vue&type=style&index=0&id=4c6b90de&scoped=true&lang=css&"
import style1 from "./proTotal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b90de",
  null
  
)

export default component.exports